<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-cascades"></i>
          <span style="margin-left: 5px">历史操作记录</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="app-container">
        <div>
          <el-table min-height="200" max-height="1000" border v-loading="listLoading" :data="tableData" style="width: 100%">
            <el-table-column prop="game_name" label="游戏名称" width="100" />
            <el-table-column prop="account" label="账号" width="100" />
            <el-table-column prop="game_role_name" label="角色名" width="100" />
            <el-table-column prop="game_server" label="区服" width="150" />
            <el-table-column prop="submit_admin_name" label="提交人" width="100" />
            <el-table-column prop="complaint_type" label="投诉类型" width="100" />
            <el-table-column prop="risk_type" label="风险类型" width="100" />
            <el-table-column prop="complaint_level" label="严重程度" width="100" />
            <el-table-column prop="after_service" label="后续沟通" width="100" />
            <el-table-column prop="upgrade_type" label="是否升级" width="100" />
            <el-table-column prop="complaint_content" label="问题详情" width="150" :show-overflow-tooltip="true" />
            <el-table-column prop="audit_admin_name" label="审批人" width="100" />
            <el-table-column prop="update_admin_name" label="修改人" width="100" />
            <el-table-column prop="submit_type" label="内部/外部" width="100" />
            <el-table-column prop="risk_level" label="风险等级" width="100" />
            <el-table-column prop="created_at" label="修改时间" />
          </el-table>
          <pagination v-show="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="historyComplaint" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Pagination from '@/components/pagination/index';
import { historyComplaintApi } from '@/api/complaint.js';
import '@/assets/css/global.css';
export default {
  components: { Pagination },
  data() {
    return {
      listQuery: {
        id: '',
        page: 1,
        limit: 10,
      },
      total: 0,
      tableData: [],
      listLoading: false,
    };
  },
  methods: {
    historyComplaint() {
      this.listLoading = true;
      historyComplaintApi(this.listQuery)
        .then((response) => {
          this.tableData = response.data.data.data;
          this.total = response.data.data.total;
          this.listLoading = false;
        })
        .catch((error) => {
          this.listLoading = false;
        });
    },
  },
  created() {
    let item = JSON.parse(this.$route.query.data);
    this.listQuery.id = item.id;
    this.historyComplaint();
  },
};
</script>
<style >
</style>